<template>
	<div class="">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="py-5 forClass-container body-height">
			<div class="flex justify-content-between flex-wrap align-items-end">
				<div class="h3 ftw900">
					{{$t('forClassIndex.onlineTeacher')}}
				</div>
				<div class="mt-1-5 main-wid-100">
					<a-input-search class="classIndex-input main-wid-100" :placeholder="$t('forClassIndex.seacher')" @search="seacherList"
						v-model="searchInfo.keyword" />
				</div>
			</div>

			<div class="row  flex flex-wrap">
				<div class="col-md-3 mt-4">
					<div class="br12 border py-1 pos-re form-select-noborder">
						<!-- <div class="pl-075">
							{{$t('forClassIndex.class')}}
						</div>
						<select class="form-select-noborder form-select ftr-1-25" aria-label="Default select example"
							v-model="searchInfo.course_id" @change="seacherList">
							<option :value="0">{{$t('forClassIndex.pleaseSelect')}}</option>
							<option :value="item.id"  v-for="(item,index) in courseList">{{item.name}}</option>
						</select>
						<a-icon type="close" size="20" class="pos-ab" style="bottom: 10px;right: 10px;"
							@click="searchInfo.course_id = 0;seacherList()"></a-icon> -->
						<div class="pl-075">
							{{$t('teacherSet.level')}}
						</div>
						<select class="form-select-noborder form-select ftr-1-25" aria-label="Default select example"
							v-model="searchInfo.grade_id" @change="seacherList">
							<option :value="0">{{$t('forClassIndex.pleaseSelect')}}</option>
							<option :value="item.value"  v-for="(item,index) in levelListCommon">{{item.name}}</option>
						</select>
						<a-icon type="close" size="20" class="pos-ab" style="bottom: 10px;right: 10px;"
							@click="searchInfo.grade_id = 0;seacherList()"></a-icon>
					</div>

				</div>
				<div class="col-md-3 mt-4">
					<div class="br12 border py-1 pos-re form-select-noborder">
						<div class="pl-075">
							{{$t('cashDesk.subject')}}
						</div>
						<select class="form-select-noborder form-select ftr-1-25" aria-label="Default select example"
							v-model="searchInfo.course_id" @change="seacherList">
							<option :value="0">{{$t('forClassIndex.pleaseSelect')}}</option>
							<option :value="item.id"  v-for="(item,index) in courseList">{{item.name}}</option>
						</select>
						<a-icon type="close" size="20" class="pos-ab" style="bottom: 10px;right: 10px;"
							@click="searchInfo.course_id = 0;seacherList()"></a-icon>
						<!-- <div class="pl-075">
							{{$t('forClassIndex.budget')}}
						</div>
						<select class="form-select ftr-1-25" @change="seacherList()" v-model="search_price">
							<option value="">{{$t('forClassIndex.pleaseSelect')}}</option>
							<option :value="0">{{getCurrency()}} {{convertCurrency(80)}}-{{getCurrency()}}{{convertCurrency(109)}}</option>
							<option :value="1">{{getCurrency()}}{{convertCurrency(116)}}-{{getCurrency()}}{{convertCurrency(146)}}</option>
							<option :value="2">{{getCurrency()}}{{convertCurrency(153)}}-{{getCurrency()}}{{convertCurrency(182)}}</option>
							<option :value="3">{{getCurrency()}}{{convertCurrency(189)}}-{{getCurrency()}}{{convertCurrency(218)}}</option>
							<option :value="4">{{getCurrency()}}{{convertCurrency(218)}}+</option>
						</select>
						<a-icon type="close" size="20" class="pos-ab" style="bottom: 10px;right: 10px;"
							@click="search_price='';seacherList()"></a-icon> -->
					</div>

				</div>
				<div class="col-md-3 mt-4">
					<div class="br12 border py-1 pos-re form-select-noborder">
						<div class="pl-075">
							{{$t('forClassIndex.pricePerSession')}}
						</div>
						<select class="form-select ftr-1-25" @change="seacherList()" v-model="search_price">
							<option value="">{{$t('forClassIndex.pleaseSelect')}}</option>
							<option :value="0">{{getCurrency()}} {{convertCurrency(80)}}-{{getCurrency()}}{{convertCurrency(109)}}</option>
							<option :value="1">{{getCurrency()}}{{convertCurrency(116)}}-{{getCurrency()}}{{convertCurrency(146)}}</option>
							<option :value="2">{{getCurrency()}}{{convertCurrency(153)}}-{{getCurrency()}}{{convertCurrency(182)}}</option>
							<option :value="3">{{getCurrency()}}{{convertCurrency(189)}}-{{getCurrency()}}{{convertCurrency(218)}}</option>
							<option :value="4">{{getCurrency()}}{{convertCurrency(218)}}+</option>
						</select>
						<a-icon type="close" size="20" class="pos-ab" style="bottom: 10px;right: 10px;"
							@click="search_price = '';seacherList()"></a-icon>
					</div>
				</div>
				<div class="col-md-3 mt-4">
					<div class="br12 border py-1 pos-re form-select-noborder">
						<div class="pl-075">
							{{$t('forClassIndex.languageInstruction')}}
						</div>
						<select class="form-select-noborder form-select ftr-1-25" aria-label="Default select example"
							v-model="searchInfo.language_id" @change="seacherList">
							<option :value="0">{{$t('forClassIndex.any')}}</option>
							<option :value="item.id" v-for="(item,index) in languageList">{{item.name}}</option>
						</select>
						<a-icon type="close" size="20" class="pos-ab" 
						style="bottom: 10px;right: 10px;" @click="searchInfo.language_id = 0"></a-icon>
					</div>
				</div>
			</div>
			<div class="flex flex-wrap">
				<select class="form-select cl-black mt-4 me-2 cl-placeholder wid-fit" v-model="searchInfo.week"
					style="color: #000 !important;" @change="seacherList()">
					<option :value="''" class="cl-black">
						{{$t('forClassIndex.classDay')}}
					</option>
					<option :value="0">{{$t('forStudy.anyTime')}}</option>
					<option :value="1">{{$t('forStudy.weekMon_weekFri')}}</option>
					<option :value="2">{{$t('forStudy.weekend')}}</option>
				</select>
				<select class="form-select cl-black mt-4 me-2 cl-placeholder wid-fit" v-model="search_time" style="color: #000 !important;"
					@change="seacherList">
					<option class="cl-black" :value="0">{{$t('forClassIndex.classTime')}}</option>
					<option class="cl-black" :value="1">12:00{{$t('forClassIndex.brfore')}}</option>
					<option class="cl-black" :value="2">12:00 - 18:00</option>
					<option class="cl-black" :value="3">18:00 - 24:00</option>
				</select>
				<select class="form-select cl-black mt-4 me-2 cl-placeholder wid-fit" v-model="searchInfo.professor_level_id"
					style="color: #000 !important;" @change="seacherList">
					<option class="cl-black" :value="0">{{$t('forClassIndex.mentorLevel')}}</option>
					<option class="cl-black" :value="1" >{{$t('forClassIndex.professionalTeacher')}}</option>
					<option class="cl-black" :value="2" >{{$t('forClassIndex.any')}}</option>
				</select>
				<!-- <select class="form-select mt-4 me-2 cl-placeholder wid-fit">
					<option selected>專長</option>
					<option value="0">英文</option>
				</select> -->
				<select class="form-select cl-black mt-4 me-2 cl-placeholder wid-fit" v-model="searchInfo.language_id"
					style="color: #000 !important;" @change="seacherList()">
					<option class="cl-black" :value="0">{{$t('forClassIndex.expertise')}}</option>
					<option class="cl-black" :value="item.id" v-for="item in languageList">{{item.name}}</option>
				</select>
				
			</div>
			<a-spin size="large" :spinning="loading">
				<!-- 符合要求的老師 -->
				<div class="mt-4 ftr-1-25 ftw600 " v-if="totalCount!=0">
					{{totalCount}}{{$t('forClassIndex.suitable')}}
				</div>
				<div class="mt-4 ftr-1-25  " v-else>
					<div class="ftw600">
						{{$t('forClassIndex.noResult')}}
					</div>
					<div>
						{{$t('forClassIndex.recommendOtherTeachers')}}
					</div>
				</div>
				<div class="row classIndex-teacher">
					<!-- 老师列表 -->
					<div class="col-md-9">
						<div class=" p-4 mb-3 br12 flex flex-wrap classIndex-item pos-re border-gray-2"
							v-for="(item, index) in teacherList" :class="{ 'active': activeIndex === index }"
							:key="index" @click="toTeacher(item.id)" @mouseenter="handleMouseEnter(index)">
							<!-- 添加鼠标悬浮事件 -->
							<!-- <img src="../../assets/image/class/collect.png" alt="" class="icon-c pos-ab"
								style="top: 10px;right: 10px;" /> -->
							<!-- 頭像部分 -->
							<div class="clickAct">
								<img :src="item.photo_image" alt="" class="headPhoto" />
								<div class="bg-pink cl-w wid-fit px-3 py-1 mt-2" style="margin: auto;">
									{{$t('forClassIndex.seniorTutor')}}
								</div>
								<!-- <div v-else>
									<div class="bg-theme cl-w wid-fit px-3 py-1 mt-2" style="margin: auto;">
										{{$t('forClassIndex.new')}}
									</div>
								</div> -->
							</div>
							<!-- 資料部分 -->
							<div class="ms-3 clickAct" style="width: 60%;">
								<div class="flex align-items-center ">
									<span class="ftw600 ft16 text-underline">{{item.name}} {{item.surname}}</span>
									 <a-popover >
									    <template #content>
											<div class="p-2">
												老師提供了身份證明文件，並已存檔
											</div>
											
									    </template>
									    <img src="../../assets/image/commom/proofId.png" alt="" class="teacherDetails-icon ml10" />
									  </a-popover>
									
									<img src="../../assets/image/commom/star-rating.png" alt="" class="teacherDetails-icon" />
								</div>
								<div class="flex align-items-center ftw600 mt-2">
									<div class="tag-blue px-2 mr10"> {{$t('forClassIndex.professionalTeacher')}}</div>
									<div class="tag-yellow px-2 mr10">  {{item.education_background_name}} </div>
									<div class="tag-orange px-2 mr10">  {{item.teacher_level_name}} </div>
								</div>
								<div class="flex wrap align-items-center mt-2 ft14 ftw600">
									<img src="../../assets/image/teacher/icon1.png" alt="" class="icon-js" />
									<div class="flex">
										<div v-for="(t,i) in item.professor_level_names"> <span v-if="i != 0">|</span> {{t}} </div>
									</div>
									
								</div>
								<div class="flex align-items-center mt-1 ft14 ftw600">
									<img src="../../assets/image/teacher/icon2.png" alt="" class="icon-js" />
									<div class="wid-fit border-theme px-2 ft14 me-2 mt-1" v-for="(t,i) in item.teacher_course">
										{{t}}
									</div>
								</div>
								<!-- <div class="flex align-items-center mt-1 ft14 ftw600">
									<img src="../../assets/image/teacher/icon3.png" alt="" class="icon-js" />
									<div>
										前DSE評卷員｜自製筆記｜有耐性｜課後答疑｜數學MC神技
									</div>
								</div> -->
								<div class="flex align-items-center mt-1 ft14 ftw600">
									<img src="../../assets/image/teacher/icon4.png" alt="" class="icon-js" />
									<!-- <span class="me-2">{{$t('forClassIndex.speek')}}:</span> -->
									<div class="wid-fit border px-2 ft14 me-2 mt-1" v-for="(t,i) in item.teacher_language
">
										{{t.language_name}}({{t.language_level_name}})
									</div>
								</div>
								<div class="mt-3 ss-d-none ftr-1-2 cl-theme ">
									{{item.synopsis}}
								</div>
								<div class="text-underline ftw600 mt-2 ss-d-none cl-theme">
									<!-- 了解詳情 -->
									{{$t('forClassIndex.learnMore')}}
								</div>
							</div>
							<div class="mt-3 ss-d-flex d-none">
								{{item.synopsis}}
							</div>
							<div class="flex flex-column justify-content-between align-items-end " style="width: 20%;">
								<div></div>
								<div class="ms-sm-3 main-wid-100 mm-r-t mt-3">
									<div class="flex ">
										<div class="text-center">
											<div class="ftr-1-25 ftw600 cl-theme">
												{{getCurrency()}}{{(convertCurrency(item.experience_price)/3).toFixed(2)}}
											</div>
											<div>
												{{$t('forClassIndex.poetryHall')}}
											</div>
											<div class="">
												25{{$t('forClassIndex.minute')}}
											</div>
										</div>
										<div class="ml10 text-center">
											<div class="ftr-1-25 ftw600 cl-theme">
												{{getCurrency()}}{{convertCurrency(item.experience_price)}}
											</div>
											<div>
												{{$t('becomeTeacher.formalClass')}}
											</div>
											<div class="">
												50{{$t('forClassIndex.minute')}}
												
											</div>
										</div>
									</div>
									<div v-if="!getTeacherIsNew(item.createtime)">
										<div class="flex justify-content-center align-items-center mt-2  ">
											<img src="../../assets/image/class/start.png" alt="" class="icon ss-d-none" />
											<span class="h4 ftw600"> 4.9</span> 
											<span class="cl-theme ftr-1 ml10 h4">傑出</span>
											<span class="cl-info h5">(240)</span>
										</div>
										<!-- <div class="flex justify-content-center align-items-center ">
											<img src="../../assets/image/class/start.png" alt="" class="icon ss-d-none" />
											2 {{$t('forClassIndex.highQualityMentor')}}
										</div> -->
										
									</div>
									<button type="button" class="btn btn-theme mt-2 py-1 br8 ftr-1-25"
										style="width: 100%;" @click.stop="toCash(item)">
										{{$t('forClassIndex.trialClass')}}
									</button>
									<!-- 聯絡導師 -->
									<!-- <button type="button" class="btn btn-outline-gray mt-2 py-1 br8 ftr-1-25"
										style="width: 100%;" @click.stop="openKefu(item.user_id)">
										{{$t('forClassIndex.contactMentor')}}
									</button> -->
								</div>
							</div>
						</div>
						<div class="flex justify-content-center mt-4">
							<a-pagination v-model:current="current" :total="totalCount" show-less-items />
						</div>
					</div>
					<!-- 对应的老师介绍 -->
					<div class="ss-d-none pos-re" style="flex: 1;width: 100%;" v-if="teacherList.length!=0">
						<div class="card shadow-sm " :style="{ top: cardTop + 'px', position: 'absolute' }"
							style=" transition: top 0.3s ease;width: 100%;"> <!-- 根据 activeIndex 显示对应的介绍 -->
							<video :src="classInfo.video_files[0] " v-if="classInfo.video_files" autoplay controls
								class="bd-placeholder-img card-img-top" style="width: 100%;height: 185px;"></video>
							<div class="text-center">{{ timeZone}}</div>
							<div class="card-body" style="padding: 0.5rem;">
								<!-- 课程表表头 -->
								<div class="timetable-header">
									<div class="timetable-cell special-cell cl-w" style="width: 50px;"></div>
									<!-- 修改 key 为索引 -->
									<div v-for="(day, colIndex) in days" :key="colIndex"
										class="timetable-cell special-cell ft12">
										<div class="">
											{{ day }}
										</div>
										<div class="">
											{{ weekDays[colIndex].date }}
										</div>
									</div>
								</div>
								<!-- 课程表主体 -->
								<div v-for="(timeSlot, rowIndex) in timeSlots" :key="rowIndex" class="timetable-row">
									<div class="timetable-cell special-cell ft12" style="width: 50px;flex: none;">
										{{ timeSlot }}</div>
									<!-- 修改 key 为列索引 -->
									<div v-for="(day, colIndex) in days" :key="`${rowIndex}-${colIndex}`"
										class="timetable-cell" :class="{ 'has-class': hasClass(rowIndex, colIndex) }">
									</div>
								</div>
								<!-- <div class="class-btn">
									{{$t('forClassIndex.viewClass')}}
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</a-spin>
		</div>
		<!-- 页脚 -->
		<footers></footers>
	</div>
</template>

<script>
import { Number } from 'core-js';

	export default {
		data() {
			return {
				// 星期几
				days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
				// 时间段
				timeSlots: ['00-04', '04-08', '08-12', '12-16', '16-20', '20-24'],
				// 课程安排，二维数组表示某天某时间段是否有课
				classes: [
					[0, 0, 0, 0, 0, 0, 0],
					[0, 0, 0, 0, 0, 0, 0],
					[0, 0, 0, 0, 0, 0, 0],
					[0, 0, 0, 0, 0, 0, 0],
					[0, 0, 0, 0, 0, 0, 0],
					[0, 0, 0, 0, 0, 0, 0],
					[0, 0, 0, 0, 0, 0, 0]
				],
				current: 1,
				activeIndex: 0, // 添加 activeIndex 变量
				cardTop: 0,

				searchInfo: {
					page: 1,
					limit: 10,
					course_id: 0,
					price_min: '', //课程价格区间
					price_max: '',
					nation_id: 0, //国家id
					week: '', //星期【英文星期名称，monday、tuesday、......】
					week_time_min: '', //星期时间区间 09:00
					week_time_max: '',
					language_id: 0, //语言id
					language_level_id: 0, //语言等级ID
					professor_level_id: 0, //教授级别ID
					special_educational_experience_id: 0, //特殊教育经验ID
					education_background_id: 0, //学历id
					keyword: '', //名称搜索
					
					grade_id:0,//年级id
				},
				search_price: '',
				search_week: 0,
				search_time: 0,
				courseList: [],
				teacherList: [],
				totalCount: 0,
				teacherTime: [],
				languageList: [],
				travelLocation: [],
				professorLevel: [],
				languageLevelL:[],
				classInfo: {},
				loading: false,
				currentDate: new Date(),
				weekStart: '',
				weekEnd: '',
				weekDays: [],
				timeZone: localStorage.getItem('timeZone') || 'UTC'
			};
		},
		async created() {
			this.getCourseList()
			console.log("-----",this.$route.query);
			this.$route.query.id ? this.searchInfo.course_id = this.$route.query.id : ''
			this.$route.query.price_min ? this.searchInfo.price_min = this.$route.query.price_min : ''
			this.$route.query.price_max ? this.searchInfo.price_max = this.$route.query.price_max : ''
			this.$route.query.search_price&&this.$route.query.search_price!='undefined' ? this.search_price = Number(this.$route.query.search_price): ''
			this.$route.query.nation_id ? this.searchInfo.nation_id = this.$route.query.nation_id : ''
			this.$route.query.week ? this.search_week = Number(this.$route.query.week)  : ''
			this.$route.query.professor_level_id ? this.searchInfo.professor_level_id = this.$route.query.professor_level_id : ''
			this.$route.query.language_level_id ? this.searchInfo.language_level_id = this.$route.query.language_level_id : ''
			this.$route.query.language_id ? this.searchInfo.language_id = Number(this.$route.query.language_id) : ''
			this.$route.query.week_time_min ? this.searchInfo.week_time_min = this.$route.query.week_time_min : ''
			this.$route.query.week_time_max ? this.searchInfo.week_time_max = this.$route.query.week_time_max : ''
			
			if(this.searchInfo.week_time_min!=''&&this.searchInfo.week_time_max!=''){
				if(this.searchInfo.week_time_min=='00:00'){
					this.search_time = 1
				}else if(this.searchInfo.week_time_min=='12:00'){
					this.search_time = 2
				}else{
					this.search_time = 3
				}
			}
			console.log("query=========",this.$route.query);
			this.getTeacherList()
			let arr = await this.informationIntegration(['language','languageLevel', 'travelLocation', 'professorLevel'])
			this.languageList = arr.list.language.list
			this.travelLocation = arr.list.travelLocation.list
			this.professorLevel = arr.list.professorLevel.list
			this.languageLevelL = arr.list.languageLevel.list
			this.calculateWeek()
		},
		methods: {
			getTeacherIsNew(targetTime){
				 const currentDate = new Date();
				  const threeMonthsAgo = new Date(currentDate);
				  threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
				  
				  // 将目标时间转换为 Date 对象
				  const targetDate = new Date(targetTime);
				  
				  // 判断目标时间是否在当前时间前三个月内 如果目标时间在前三个月内，返回 true；否则返回 false
				  return targetDate >= threeMonthsAgo && targetDate <= currentDate;
			},
			calculateWeek() {
				const current = new Date(this.currentDate);
				// 获取当前是星期几，0 代表周日
				const dayOfWeek = current.getDay();
				const startOffset = dayOfWeek;
				const start = new Date(current.setDate(current.getDate() - startOffset));
				const end = new Date(start);
				end.setDate(end.getDate() + 6);

				this.weekStart = this.formatDate(start);
				this.weekEnd = this.formatDate(end);

				this.weekDays = [];
				for (let i = 0; i < 7; i++) {
					const day = new Date(start);
					day.setDate(day.getDate() + i);
					this.weekDays.push({
						date: this.formatDate(day),
					});
				}
			},
			formatDate(date) {
				return `${String(date.getDate()).padStart(2, '0')}`;
			},
			seacherList() {
				this.searchInfo.page = 1
				if (this.search_price === '') {
					this.searchInfo.price_min = ''
					this.searchInfo.price_max = ''
				} else if (this.search_price === 0) {
					this.searchInfo.price_min = 80
					this.searchInfo.price_max = 109
				} else if (this.search_price == 1) {
					this.searchInfo.price_min = 116
					this.searchInfo.price_max = 146
				} else if (this.search_price == 2) {
					this.searchInfo.price_min = 153
					this.searchInfo.price_max = 182
				} else if (this.search_price == 3) {
					this.searchInfo.price_min = 189
					this.searchInfo.price_max = 218
				} else if (this.search_price == 4) {
					this.searchInfo.price_min = 218
					this.searchInfo.price_max = ''
				}

				// if (this.search_week == 0) {
				// 	this.searchInfo.week = ''
				// } else if (this.search_week == 1) {

				// } else {

				// }

				if (this.search_time == 0) {
					this.searchInfo.week_time_min = ''
					this.searchInfo.week_time_max = ''
				} else if (this.search_week == 1) {
					this.searchInfo.week_time_min = '00:00'
					this.searchInfo.week_time_max = '12:00'
				} else if (this.search_week == 2) {
					this.searchInfo.week_time_min = '12:00'
					this.searchInfo.week_time_max = '18:00'
				} else {
					this.searchInfo.week_time_min = '18:00'
					this.searchInfo.week_time_max = '24:00'
				}

				this.getTeacherList()
			},
			getTeacherList() {
				if (this.loading) return
				this.loading = true
				this.$http.api('teachers/teacherList', this.searchInfo).then(res => {
					this.loading = false
					this.teacherList = res.list
					if(res.list.length==0){
						// 搜不到课程时，单独调一遍以展示相似的推荐老师
						this.$http.api('teachers/teacherList', {
							course_id:this.searchInfo.course_id
						}).then(res=>{
							this.teacherList = res.list
						})
					}
					this.totalCount = res.count
					this.teacherTime = res.list[0].teacher_time
					this.classInfo = res.list[0]
					this.convertTeacherTimeToClasses();
				}).catch(err => {
					this.loading = false
				})
			},
			// 将 teacher_time 数据转换为 classes 格式
			convertTeacherTimeToClasses() {
				// 初始化 classes 数组
				this.classes = Array.from({
						length: this.timeSlots.length
					}, () =>
					Array(this.days.length).fill(0)
				);

				this.teacherTime.forEach(item => {
					const daySwitches = {
						'S': [item.sunday_switch, item.saturday_switch],
						'M': item.monday_switch,
						'T': [item.tuesday_switch, item.thursday_switch],
						'W': item.wednesday_switch,
						'F': item.friday_switch
					};

					const minHour = parseInt(item.min_time.split(':')[0]);
					const maxHour = parseInt(item.max_time.split(':')[0]);

					this.timeSlots.forEach((timeSlot, rowIndex) => {
						const [start, end] = timeSlot.split('-').map(Number);
						if (minHour < end && maxHour > start) {
							this.days.forEach((day, colIndex) => {
								let switchValue = 0;
								if (day === 'S') {
									switchValue = colIndex === 0 ? daySwitches[day][0] :
										daySwitches[day][1];
								} else if (day === 'T') {
									switchValue = colIndex === 2 ? daySwitches[day][0] :
										daySwitches[day][1];
								} else {
									switchValue = daySwitches[day];
								}

								if (switchValue === 1) {
									this.classes[rowIndex][colIndex] = 1;
								}
							});
						}
					});
				});
				// console.log("--------------", this.classes);
			},
			getCourseList() {
				this.$http.api('course/courseList', {

				}).then(res => {
					this.courseList = res.list
				})
			},
			// 判断某个时间段是否有课
			hasClass(rowIndex, colIndex) {
				return this.classes[rowIndex][colIndex] === 1;
			},
			toTeacher(id) {
				this.$router.push('/teacher?id=' + id);
			},
			toCash(item) {
				this.$http.api('course/classifyList',{
					includeCourse:1,
					teacherCourse:item.id
				}).then(res=>{
					this.$router.push('/cashDesk?teacherId='+item.id+'&teacherName='+item.name+
					'&teacherPhoto='+item.photo_image+'&testPrice='+item.experience_price+
					'&teacher_course_id='+res.list[0].course[0].teacherCourse[0].id+'&test='+res.list[0].course[0].teacherCourse[0].is_experience)
					// this.$router.push('/appointment?id='+res.list[0].id)
				})
			},
			handleMouseEnter(index) { // 添加鼠标悬浮处理方法
				this.activeIndex = index;
				this.classInfo = this.teacherList[index]
				// 获取悬浮元素的位置
				const itemElement = document.querySelectorAll('.classIndex-item')[index];
				const referenceElement = document.querySelector('.classIndex-teacher');
				if (itemElement && referenceElement) {
					// 获取包含块的滚动偏移量
					const container = document.querySelector('.forClass-container');
					const containerScrollTop = container ? container.scrollTop : 0;
					// 获取 itemElement 相对于文档顶部的位置
					const itemRect = itemElement.getBoundingClientRect();
					const itemTop = itemRect.top + window.pageYOffset;
					// 获取 referenceElement 相对于文档顶部的位置
					const referenceRect = referenceElement.getBoundingClientRect();
					const referenceTop = referenceRect.top + window.pageYOffset;
					// 计算 card 应该显示的位置
					this.cardTop = itemTop - referenceTop - containerScrollTop;
				}
				this.teacherTime = this.teacherList[this.activeIndex ].teacher_time
				this.convertTeacherTimeToClasses();
				// this.timeSlots
			}
		}
	};
</script>

<style scoped lang="less">
	.teacherDetails-icon {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	.pl-075 {
		padding-left: .75rem;
	}

	.classIndex-item.active {
		border: 2px solid #52C4C9 !important;
	}

	.classIndex-item {
		.headPhoto {
			width: 120px;
			height: 120px;
		}

		.icon {
			width: 30px;
			height: 30px;
		}

		.icon-js {
			width: 20px;
			height: 20px;
			margin-right: 5px;
		}

		.icon-c {
			width: 32px;
			height: 32px;
		}
	}

	.class-btn {
		background-color: #C6C8CA;
		width: 100%;
		text-align: center;
		padding: 12px 0;
		color: #fff;
		margin-top: 20px;
		border-radius: 10px;
	}

	::v-deep.classIndex-input .ant-input {
		border-radius: 10px;
		width: 300px;
		font-size: 1rem;
		height: 45px;
	}

	.form-select-noborder .form-select {
		background-color: transparent;
		border: none;
		background-image: none;
		width: fit-content;
		font-weight: 600;
		/* padding: 0; */
	}

	.form-select:focus {
		outline: none;
		box-shadow: none;
	}

	.timetable-header,
	.timetable-row {
		display: flex;
		width: 100%;
	}

	.timetable-cell {
		border: none;
		padding: 6px;
		flex: 1;
		text-align: center;
		background-color: #E6E6E6;
		border: 1px solid #fff;
	}

	.special-cell {
		background-color: transparent; // 去除背景色
	}

	.has-class {
		background-color: #52C4C9;
		color: white;
	}

	@media (max-width:575.98px) {
		.forClass-container {
			margin: auto;
			width: 93%;
		}

		.main-wid-100 {
			width: 100% !important;
		}

		.p-10 {
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}

		.mt-1-5 {
			margin-top: 1.5rem;
		}

		::v-deep.classIndex-input .ant-input {
			width: 100% !important;
		}

		.classIndex-item {
			.headPhoto {
				width: 94px;
				height: 80px;
			}
		}
	}

	@media (min-width: 576px) {
		.forClass-container {
			margin: auto;
			width: 600px;
		}

	}

	@media (min-width: 768px) {
		.forClass-container {
			margin: auto;
			width: 800px;
		}
	}

	@media (min-width: 992px) {
		.forClass-container {
			margin: auto;
			width: 900px;
		}
	}

	@media (min-width: 1200px) {
		.forClass-container {
			margin: auto;
			width: 1100px;
		}
	}

	@media (min-width: 1400px) {
		.forClass-container {
			margin: auto;
			width: 1200px;
		}
	}
</style>